module.exports = __webpack_public_path__ + "static/media/canada.9cd30d2d.JPG";